"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFeatureFlagFacilityDto = instanceOfFeatureFlagFacilityDto;
exports.FeatureFlagFacilityDtoFromJSON = FeatureFlagFacilityDtoFromJSON;
exports.FeatureFlagFacilityDtoFromJSONTyped = FeatureFlagFacilityDtoFromJSONTyped;
exports.FeatureFlagFacilityDtoToJSON = FeatureFlagFacilityDtoToJSON;
exports.FeatureFlagFacilityDtoToJSONTyped = FeatureFlagFacilityDtoToJSONTyped;
/**
 * Check if a given object implements the FeatureFlagFacilityDto interface.
 */
function instanceOfFeatureFlagFacilityDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
function FeatureFlagFacilityDtoFromJSON(json) {
    return FeatureFlagFacilityDtoFromJSONTyped(json, false);
}
function FeatureFlagFacilityDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
    };
}
function FeatureFlagFacilityDtoToJSON(json) {
    return FeatureFlagFacilityDtoToJSONTyped(json, false);
}
function FeatureFlagFacilityDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
    };
}
//# sourceMappingURL=FeatureFlagFacilityDto.js.map